import { Controller } from "@hotwired/stimulus"

// Asks for notification permission only on an explicit click -- asking on page load gets
// auto-blocked by Chrome. See plans/operations-intelligence/06-notifications.md.
export default class extends Controller {
  async subscribe(event) {
    event.preventDefault()

    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      alert("Push notifications aren't supported in this browser.")
      return
    }

    const vapidMeta = document.querySelector('meta[name="vapid-public-key"]')
    if (!vapidMeta) {
      alert("Push notifications aren't configured yet.")
      return
    }

    const permission = await Notification.requestPermission()
    if (permission !== "granted") return

    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlBase64ToUint8Array(vapidMeta.content)
    })

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    await fetch("/push_subscriptions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({subscription: subscription.toJSON()})
    })

    this.element.textContent = "Notifications enabled"
    this.element.disabled = true
  }

  urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
    const rawData = window.atob(base64)
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)))
  }
}
